module.exports = __webpack_public_path__ + "assets/img/bg_orange.png";